<template>
    <div class="withdraw_wrap">
        <img src="../images/share/recharge_bg.png" class="myteam-bg">
        <div class="base-header">
            <div class="big_tit" @click="$router.push('invest')">{{ $t('充值') }}</div>
            <div :class="is_active ? 'big_tit is-active' : 'big_tit'">{{ $t('提现') }}</div>
        </div>
        <div class="ablewd">
            <div class="left-ab">
                <div class="desc-ab">{{ $t("可提现金额") }}</div>
                <div class="desc-num">{{ $t("钱符") }} {{ able_money }}</div>
            </div>
        </div>

        <div class="enther">
            <p class="endes">{{ $t("请输入您的数量") }} ({{ $t("最低") }}{{ min_withdraw_amount }})</p>
            <input type="text" class="amount-input" :placeholder="$t('请输入提现数量')" v-model="money" />
            <p class="fee">{{ $t("提现手续费") }}: {{ withdraw_rate }}% </p>
        </div>

        <div class="enther" >
            <p class="endes">{{ $t("电话号码") }}</p>
            <input v-if="!is_withdraled" type="text" class="amount-input" v-model="phone_number" :placeholder="$t('请输入电话号码')" />
            <input v-if="is_withdraled" type="text" class="amount-input cantc" v-model="phone_number"  readonly />
        </div>

        <!-- <div class="enther">
            <p class="endes">{{ $t("Pix type") }}</p>
            <input type="text" class="amount-input" readonly value="CPF" />
        </div> -->

        <div class="enther">
            <p class="endes">{{ $t("Chave Pix(CPF)") }}</p>
            <input type="text" v-if="!is_withdraled" class="amount-input" :placeholder="$t('Input Pix(CPF)')" v-model="chave_pix" />
            <input type="text" v-if="is_withdraled" class="amount-input cantc"  v-model="chave_pix" readonly />
        </div>

        <div class="enther">
            <p class="endes">{{ $t("CPF") }}</p>
            <input type="text" v-if="!is_withdraled" class="amount-input" :placeholder="$t('Input CPF')" v-model="cpf" />
            <input type="text" v-if="is_withdraled" class="amount-input cantc" readonly v-model="cpf" />
        </div>

        <!-- <div class="enther">
            <p class="endes">{{ $t("Email") }}</p>
            <input type="text" class="amount-input" :placeholder="$t('Input Email address')" v-model="email" />
        </div> -->

        <div class="sbtn" @click="submit">
            {{ $t("提现") }}
        </div>

        <ft></ft>
    </div>
</template>

<script>
import Vue from "vue";
import Fetch from "../../utils/fetch";
import ft from "../../components/ft.vue"
import baseHeader from "@/components/baseHeader";
export default {
    name: "cost",
    data() {
        return {
            able_money: 0, //可以提现金额
            money: null,
            phone_number: "",
            chave_pix: "",
            cpf: "",
            email: "",
            min_withdraw_amount: null,
            withdraw_rate: null,
            is_active: false,
            is_withdraled:false,
        };
    },
    components:
    {
        baseHeader,
        ft,
    },
    created() {
        this.$parent.footer("invest");
    },
    mounted() {
        if (this.$route.name == "cash") {
            this.is_active = true;
        }
        // Fetch("/Withdrow/withdraw_info").then((res) => {
        //     console.log(res);
        //     if(res.data.length > 0){
        //         this.is_withdraled = true;
        //         this.phone_number = res.data.phone_number;
        //         this.chave_pix = res.data.chave_pix;
        //         this.cpf = res.data.cpf;
        //     }
        // });
        this.getWdAble();
    },
    methods: {
        back() {
            this.$router.go(-1)
        },
        //获取可以提现的金额
        getWdAble() {
            Fetch("/user/getWithdrawInfo").then((res) => {
                //console.log(res);
                this.able_money = res.data.can_withdraw_amount;
                this.min_withdraw_amount = res.data.min_withdraw_amount;
                //console.log(this.min_withdraw_amount);
                this.withdraw_rate = res.data.withdraw_rate;
                this.chave_pix = res.data.cpf;
                this.cpf = res.data.cpf;
            });
        },
        //提现
        submit() {
            //没有可提现的金额
            if (this.able_money <= 0) {
                this.$toast({
                    background: "#07c160",
                    message: this.$t("当前可提现金额为0"),
                    duration: 3000,
                });
                return false;
            }
            //提现金额验证
            let amount_reg = /^[1-9][0-9]*([.][0-9]{1,2})?$/;
            if (!amount_reg.test(this.money)) {
                this.$toast({
                    background: "#07c160",
                    message: this.$t("提现金额不正确"),
                    duration: 3000,
                });
                return false;
            }
            //提现金额 大于可提现金额
            if (Number(this.money) > Number(this.able_money)) {
                this.$toast({
                  
                    background: "#07c160",
                    message: this.$t("提现金额大于可提现金额"),
                    duration: 3000,
                });
                return false;
            }

            if (Number(this.money) < Number(this.min_withdraw_amount)) {
                this.$toast({
                    background: "#07c160",
                    message: this.$t("提现金额小于最低提现金额"),
                    duration:3000,
                });
                return false;
            }

            //验证电话号码
            let phone_reg = /^\d{9,}$/;
            if (!phone_reg.test(this.phone_number)) {
                this.$toast({
                    background: "#07c160",
                    message: this.$t("手机号码不正确"),
                    duration:3000,
                });
                return false;
            }


            //验证Chave Pix
            if (this.chave_pix.length < 8 || this.chave_pix.length > 64) {
                this.$toast({
                    background: "#07c160",
                    message: this.$t("Chave Pix(CPF) 不正确"),
                    duration: 3000,
                });
                return false;
            }

            //验证CPF
            if (this.cpf.length < 9 || this.chave_pix.length > 11) {
                this.$toast({
                    background: "#07c160",
                    message: this.$t("CPF不正确"),
                    duration: 3000,
                });
                return false;
            }

            //终于通过验证了
            Fetch('/Withdrow/addWithdraw', {
                money: this.money,
                phone_number: this.phone_number,
                chave_pix: this.chave_pix,
                cpf: this.cpf,
                email: this.email,
            }).then(res => {
                //console.log(res);
                if (res.code == 1) {
                    this.$toast({
                        type: "success",
                        background: "#07c160",
                        message: this.$t("提现成功"),
                        duration: 2000,
                    });
                    setTimeout(() => {
                        this.$router.push('/cashlist')
                    });
                } else {
                    this.$toast({
                        background: "#07c160",
                        message: res.msg,
                        duration: 3000,
                    });
                }
            })


        },
    },
};
</script>

<style lang="less" scoped>
.myteam-bg {
    width: 100%;
    height: 3.0rem;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
}
.cantc{
    background-color: rgb(22, 22, 19)!important;
    font-weight: 700;
}
.base-header {
    position: relative;
    height: 0.9rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 92%;
    margin: 10px auto;
    border-radius: 5px;
    overflow: hidden;
    margin-top: 1.5rem;
    z-index: 2;
    border: 1px solid #84A559;
    box-sizing: border-box;
    padding: 5px 5px;
}

.big_tit {
    font-size: 0.35rem;
    text-align: center;
    width: 49%;
    height: 0.7rem;
    line-height: 0.7rem;
    color: #84A559;
    font-weight: 700;
    border-radius: 5px;
}

.is-active {
    color: #fff;
    background: #84A559;
}



.fee {
    color: #90d934;
    margin-top: 0.4rem;

}

.amount-input {
    height: 40px;
    width: 100%;
    border: 1px solid #84A559;
    margin-top: 10px;
    font-size: 14px;
    color: white;
    text-indent: 10px;
    border-radius: 5px;
}
.amount-input::placeholder{
    font-size: 0.33rem;
    color: #84A559;
}

.enther {
    width: 90%;
    margin: 15px auto 10px;
}

.endes {
    color: #84A559;
    font-size: 0.32rem;
}

.desc-num {
    margin-left: 15px;
    color: #90d934;
}

.desc-ab {
    text-align: left;
    box-sizing: border-box;
}

.left-ab {
    width: 100%;
    height: 30px;
    color: #84A559;
    display: flex;
    align-items: center;
}

.ablewd {
    width: 90%;
    margin: 15px auto 0;
}

.free-count {
    color: #989da6;
}

.basic_btn {
    background: #5ed964;
    margin: 15px auto 0;
    background: url("../images/login/submit.png") no-repeat;
    background-size: 100%;
    color: #132816;
    font-weight: 700;

}

.withdraw_wrap {
    background: url("../images/vip/sbg.png") repeat;
    min-height: 100vh;
    margin-top: 0;
    padding-bottom: 3rem;
}
.sbtn {
    margin: 23px auto 0 auto;
    width: 90%;
    border-radius: 22px;
    font-size: 0.5rem;
    font-weight: 700;
    height: 2rem;
    line-height: 3rem;
    text-align: center;
    color: #fff;
    background: url("../images/share/rg-btn.png") no-repeat;
    background-size: 100% 100%;
    margin-bottom: 1rem;
}
</style>
